import { Button } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

function PaymentSuccess() {
  const location = useLocation();

  const [transactionId, setTransactionId] = useState<string>('');
  const [callbackUrl, setCallbackUrl] = useState<string>('');

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id') || '';
    const callbackUrl = queryParams.get('callback_url') || '';

    setTransactionId(id);
    setCallbackUrl(callbackUrl);
  }, []);

  return (
    <Box>
      <Box textAlign='center'>
        <img
          src='/images/check.png'
          alt='check'
          width='60'
          style={{ marginBottom: '18px' }}
        />
        <Typography variant='h6' gutterBottom>
          Payment Successful!
        </Typography>
        {transactionId && (
          <div>
            <text
              style={{
                fontSize: '14px',
                color: '#9B9B9B',
                fontWeight: 400,
                marginTop: '8px',
                display: 'block',
              }}
            >
              Transaction ID: <b>{transactionId}</b>
            </text>
          </div>
        )}
        {callbackUrl && (
          <Button
            style={{
              marginTop: '8px',
              textTransform: 'none',
              backgroundColor: 'rgb(34, 139, 230)',
              color: '#fff', // Ensure text color is white for better readability
              fontWeight: 600, // Semibold
              fontSize: '14px',
              fontFamily: '"Segoe UI Semibold", "Segoe UI", sans-serif', // Fallback to Segoe UI or sans-serif if Semibold is not available
            }}
            href={callbackUrl}
            variant='contained'
            color='primary'
          >
            Back to merchant
          </Button>
        )}
      </Box>
    </Box>
  );
}

export default PaymentSuccess;
